import { atom } from "recoil";

export const BookActiveAtom = atom({
  key: "BookActiveAtom",
  default: null,
});
